"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTagJudgesProperty = exports.tagJudgesPropertyDefinition = void 0;
exports.tagJudgesPropertyDefinition = {
    name: 'tag-judges',
    type: 'asset',
    multiple: true,
    view: {
        hint: 'Related to a judge? Tag it and the asset shows on the judge collection page.',
        label: 'Judges',
        style: '',
    },
    constraints: [
        {
            name: 'stencils',
            argument: ['judge'],
        },
    ],
};
const isTagJudgesProperty = (prop) => {
    return prop.name === exports.tagJudgesPropertyDefinition.name;
};
exports.isTagJudgesProperty = isTagJudgesProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGFnLWp1ZGdlcy5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3RhZy1qdWRnZXMucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSwyQkFBMkIsR0FBRztJQUN6QyxJQUFJLEVBQUUsWUFBWTtJQUNsQixJQUFJLEVBQUUsT0FBTztJQUNiLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFO1FBQ0osSUFBSSxFQUFFLDhFQUE4RTtRQUNwRixLQUFLLEVBQUUsUUFBUTtRQUNmLEtBQUssRUFBRSxFQUFFO0tBQ1Y7SUFDRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxDQUFDLE9BQU8sQ0FBQztTQUNwQjtLQUNGO0NBQzhCLENBQUE7QUFJMUIsTUFBTSxtQkFBbUIsR0FBRyxDQUFDLElBQWtCLEVBQTZCLEVBQUU7SUFDbkYsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLG1DQUEyQixDQUFDLElBQUksQ0FBQTtBQUN2RCxDQUFDLENBQUE7QUFGWSxRQUFBLG1CQUFtQix1QkFFL0IifQ==